import { Link } from 'react-router-dom';
import type { Movie } from '../../../mocks/movies';

interface Props {
  current: Movie;
  all: Movie[];
}

export default function RelatedSection({ current, all }: Props) {
  const related = all
    .filter(m => m.id !== current.id && m.genre.some(g => current.genre.includes(g)))
    .slice(0, 6);

  if (related.length === 0) return null;

  const typeLabel = (t: string) =>
    t === 'movie' ? 'فيلم' : t === 'series' ? 'مسلسل' : 'رسوم متحركة';

  return (
    <div className="mt-16">
      <h3 className="text-xl font-black text-gray-900 mb-6 flex items-center gap-2">
        <div className="w-6 h-6 flex items-center justify-center">
          <i className="ri-film-line text-[#C9A961] text-xl" />
        </div>
        قد يعجبك أيضاً
      </h3>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
        {related.map(movie => (
          <Link
            key={movie.id}
            to={`/movies/${movie.id}`}
            className="group cursor-pointer"
          >
            <div className="relative rounded-xl overflow-hidden" style={{ paddingBottom: '145%' }}>
              <img
                src={movie.poster}
                alt={movie.title}
                className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent" />
              <div className="absolute top-2 right-2 bg-[#C9A961] text-white text-[10px] font-black px-1.5 py-0.5 rounded">
                {typeLabel(movie.type)}
              </div>
              <div className="absolute top-2 left-2 text-[10px] font-black text-[#C9A961] bg-black/60 px-1.5 py-0.5 rounded">
                25 د.إ
              </div>
              <div className="absolute bottom-0 right-0 left-0 p-3">
                <p className="text-white font-bold text-xs leading-tight line-clamp-2">{movie.title}</p>
                <div className="flex items-center gap-1 mt-1">
                  <div className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-star-fill text-[#C9A961] text-[10px]" />
                  </div>
                  <span className="text-[#C9A961] text-[11px] font-black">{movie.rating}</span>
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
